<template>
  <div class="cx-datePicker has-no-style" v-if="show">
    <template v-if="dateType === 'date' || dateType === 'datetime'">
      <el-date-picker
          ref="datePickerDiv"
          class="style-wrap"
          v-model="value"
          :type="dateType"
          :style="getStyle"
          :append-to-body="appendToBody"
          :format="dateFormat"
          :value-format="dateFormatValue"
          @change="changeDate"
          @blur="blurDateFn"
          placeholder="选择日期时间"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :popper-class="appendToBodyClass"
          :picker-options="pickerOptions"
      >
      </el-date-picker>
    </template>
    <template v-else>
    <el-date-picker
      ref="datePickerDiv"
      class="style-wrap"
      v-model="value"
      :type="dateType"
      :style="getStyle"
      :append-to-body="appendToBody"
      :format="dateFormat"
      :value-format="dateFormatValue"
      @change="changeDate"
      @blur="blurDateFn"
      placeholder="选择日期时间"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :default-time="rangeDefaultTime"
      :popper-class="appendToBodyClass"
    >
    </el-date-picker>
    </template>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import { isSsrPage } from "utils"
import plugins from "./plugin"
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
export default {
  mixins: [eventMixin, plugins, subPageEventMixin],
  props: {
    options: {
      type: Object,
      required: true
    },
    myid: {
      type: Object,
      default: null
    }
  },
  mounted() {
    if(this.request_prefix === "appStage"){
      // this.appendToBody = true
      this.appendToBodyClass = "app-style-panel"
      if (this.dataPickerType === 3) {
        this.appendToBodyClass = "app-style-panel width414"
      }
    }else{
      this.appendToBody = false
    }
    this.$initPlugin(this.options?.pluginName)
    if (this.options.defaultToday && this.isBigScreenPreview()) {
      this.changeToNow()
    }
    const _this = this
    this.pickerOptions = {
      disabledDate(time) {
        return _this.disabledDateFun(time);
      },
    }
  },
  computed: {
    startDateFlag() {
      return this.options.startDateFlag ?? 6
    },
    endDateFlag() {
      return this.options.endDateFlag ?? 6
    },
    ids() {
      return this.myid
    },
    activeId() {
      return this.$store.state.states.activeID
    },
    value: {
      get() {
        let val = this.options.value
        //  判断 日期 是否为 ISO 8601格式【示例：2024-07-18T03:07:18.619Z】，修改为标准时间格式 示例：Thu Jul 18 2024 11:30:47 GMT+0800 (中国标准时间)
        if(typeof val === "string" && val.indexOf("-") > 0 && val.indexOf("T") > 0 && val.indexOf(".") > 0 && val.indexOf("Z") > 0 ){
          val = new Date(val)
        }
        return val
      },
      set(val) {
        console.log('dispatchListPageRefreshData', val)
        if (this.isInListPage) {
          this.formatFilterValue(val)
        }
        if (this.isInSubPage) {
          this.dispatchListPageRefreshData(val)
        }
        this.$changeOptionsEV(val, "value", false, undefined, this.myid)
      }
    },
    dateType() {
      return this.options.dateType
    },
    dateFormat() {
      return this.options.dateFormat
    },
    dateFormatValue() {
      if (this.dateType === "week") {
        return ""
      } else {
        return this.options.dateFormat
      }
    },
    dataPickerType() {
      return this.options.dataPickerType
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          // tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.options.boxShadowColor[index]}`
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        // tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.options.boxShadowColor}`
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    // 时间选择器弹框的标题栏样式
    getPopperTitleStyle() {
      let padding
      if (this.options.titlePaddingTypeFlag === 1) {
        padding = this.options.titlePadding + "px"
      } else {
        padding = `${this.options.titlePaddingTop}px ${this.options.titlePaddingRight}px ${this.options.titlePaddingBottom}px ${this.options.titlePaddingLeft}px`
      }
      // let color = this.options.titleTextIsThemeColor
      //   ? this.themeColor
      //   : this.options.titleColor.color
      //   ? this.options.titleColor.color
      //   : this.options.titleColor
      let color = this.$parseColor(this.options.titleColor, {
        isThemeColor: this.options.titleTextIsThemeColor
      })
      // let titleBgColor = this.options.titleBgColorIsThemeColor
      //   ? this.themeColor
      //   : this.options.titleBgColor.color
      //   ? this.options.titleBgColor.color
      //   : this.options.titleBgColor
      let titleBgColor = this.$parseColor(this.options.titleBgColor, {
        isThemeColor: this.options.titleBgColorIsThemeColor
      })
      return {
        "--titleLineHeight": this.options.titleLineHeightType === '%' ? (this.options.titleLineHeight / 100) : (this.options.titleLineHeight  + "px"),
        "--titleTextAlign": this.options.titleTextAlign,
        "--titleWritingMode": this.options.titleWritingMode,
        "--titleLetterSpacing": this.options.titleLetterSpacing + "px",
        "--titleTextDecoration": this.options.titleTextDecoration,
        "--titleTextDecorationColor": color,
        "--titleFontFamily": this.options.titleFontFamily,
        "--titleFontSize": this.options.titleFontSize + "px",
        "--titleFontWeight": this.options.titleFontWeight,
        "--titleFontStyle": this.options.titleFontStyle,
        "--titlePadding": padding,
        "--titleBackground": titleBgColor,
        "--titleColor": color
      }
    },
    // 时间选择器 弹框中的分割线样式
    getLineStyle() {
      return {
        // "--lineColor": this.options.lineColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.lineColor.color
        //   ? this.options.lineColor.color
        //   : this.options.lineColor
        "--lineColor": this.$parseColor(this.options.lineColor, {
          isThemeColor: this.options.lineColorIsThemeColor
        })
      }
    },
    // 非本月日期样式
    getNotCurrentMonthStyle() {
      return {
        // "--notCurrentMonthColor": this.options.notCurrentTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.notCurrentTextColor.color
        //   ? this.options.notCurrentTextColor.color
        //   : this.options.notCurrentTextColor
        "--notCurrentMonthColor": this.$parseColor(this.options.notCurrentTextColor, {
          isThemeColor: this.options.notCurrentTextIsThemeColor
        })
      }
    },
    // 日期hover样式
    getHoverStyle() {
      let borderRadiusTopLeft,
        borderRadiusTopRight,
        borderRadiusBottomRight,
        borderRadiusBottomLeft,
        borderColor,
        background
      if (this.options.hoverBorderTypeFlag === 2) {
        borderRadiusTopLeft = this.options.hoverBorderRadius + "px"
        borderRadiusTopRight = this.options.hoverBorderRadius + "px"
        borderRadiusBottomRight = this.options.hoverBorderRadius + "px"
        borderRadiusBottomLeft = this.options.hoverBorderRadius + "px"
      } else {
        borderRadiusTopLeft = this.options.hoverBorderTopLeftRadius + "px"
        borderRadiusTopRight = this.options.hoverBorderTopRightRadius + "px"
        borderRadiusBottomRight = this.options.hoverBorderBottomRightRadius + "px"
        borderRadiusBottomLeft = this.options.hoverBorderBottomLeftRadius + "px"
      }
      // background = this.options.hoverBgColorIsThemeColor
      //   ? this.themeColor
      //   : this.options.hoverBgColor.color
      //   ? this.options.hoverBgColor.color
      //   : this.options.hoverBgColor
      background = this.$parseColor(this.options.hoverBgColor, {
        isThemeColor: this.options.hoverBgColorIsThemeColor
      })
      // borderColor = this.options.hoverBorderIsThemeColor
      //   ? this.themeColor
      //   : this.options.hoverBorderColor.color
      //   ? this.options.hoverBorderColor.color
      //   : this.options.hoverBorderColor
      borderColor = this.$parseColor(this.options.hoverBorderColor, {
        isThemeColor: this.options.hoverBorderIsThemeColor
      })
      return {
        "--hoverBorder": this.options.showHoverBorder ? `1px solid ${borderColor}` : "",
        "--hoverBackground": background,
        "--hoverBorderRadiusTopLeft": borderRadiusTopLeft,
        "--hoverBorderRadiusTopRight": borderRadiusTopRight,
        "--hoverBorderRadiusBottomRight": borderRadiusBottomRight,
        "--hoverBorderRadiusBottomLeft": borderRadiusBottomLeft,
        "--hoverColor": this.$parseColor(this.options.hoverFontColor),
        "--hoverFontWeight": this.options.hoverFontWeight,
        "--hoverFontSize": this.options.hoverFontSize + "px",
        "--hoverFontFamily": this.options.hoverFontFamily
      }
    },
    // 选中日期样式
    getSelectedStyle() {
      let borderRadiusTopLeft,
        borderRadiusTopRight,
        borderRadiusBottomRight,
        borderRadiusBottomLeft,
        borderColor,
        background
      if (this.options.activeBorderTypeFlag === 2) {
        borderRadiusTopLeft = this.options.activeBorderRadius + "px"
        borderRadiusTopRight = this.options.activeBorderRadius + "px"
        borderRadiusBottomRight = this.options.activeBorderRadius + "px"
        borderRadiusBottomLeft = this.options.activeBorderRadius + "px"
      } else {
        borderRadiusTopLeft = this.options.activeBorderTopLeftRadius + "px"
        borderRadiusTopRight = this.options.activeBorderTopRightRadius + "px"
        borderRadiusBottomRight = this.options.activeBorderBottomRightRadius + "px"
        borderRadiusBottomLeft = this.options.activeBorderBottomLeftRadius + "px"
      }
      // background = this.options.activeBgColorIsThemeColor
      //   ? this.themeColor
      //   : this.options.activeBgColor.color
      //   ? this.options.activeBgColor.color
      //   : this.options.activeBgColor
      background = this.$parseColor(this.options.activeBgColor, {
        isThemeColor: this.options.activeBgColorIsThemeColor
      })
      // borderColor = this.options.activeBorderIsThemeColor
      //   ? this.themeColor
      //   : this.options.activeBorderColor.color
      //   ? this.options.activeBorderColor.color
      //   : this.options.activeBorderColor
      borderColor = this.$parseColor(this.options.activeBorderColor, {
        isThemeColor: this.options.activeBorderIsThemeColor
      })
      return {
        "--activeBorder": this.options.showActiveBorder ? `1px solid ${borderColor}` : "",
        "--activeBackground": background,
        "--activeBorderRadiusTopLeft": borderRadiusTopLeft,
        "--activeBorderRadiusTopRight": borderRadiusTopRight,
        "--activeBorderRadiusBottomRight": borderRadiusBottomRight,
        "--activeBorderRadiusBottomLeft": borderRadiusBottomLeft,
        "--activeColor": this.$parseColor(this.options.activeFontColor),
        "--activeFontWeight": this.options.activeFontWeight,
        "--activeFontSize": this.options.activeFontSize + "px",
        "--activeFontFamily": this.options.activeFontFamily
      }
    },
    // 按钮样式
    getBtnStyle() {
      let primaryBorderW = "",
        cancleBorderW = ""
      if (Array.isArray(this.options.primaryBtnBorderWidth)) {
        this.options.primaryBtnBorderWidth.forEach(item => [(primaryBorderW += ` ${item}px`)])
      } else {
        primaryBorderW += ` ${this.options.primaryBtnBorderWidth}px`
      }
      if (Array.isArray(this.options.cancleBtnBorderWidth)) {
        this.options.cancleBtnBorderWidth.forEach(item => [(cancleBorderW += ` ${item}px`)])
      } else {
        cancleBorderW += ` ${this.options.cancleBtnBorderWidth}px`
      }
      return {
        "--primaryFontColor": this.$parseColor(this.options.primaryBtnFontColor),
        "--primaryFontFamily": this.options.primaryBtnFontFamily,
        "--primaryFontSize": this.options.primaryBtnFontSize + "px",
        "--primaryFontWeight": this.options.primaryBtnFontWeight,
        // "--primaryBgColor": this.options.primaryBtnBgColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.primaryBtnBgColor.color
        //   ? this.options.primaryBtnBgColor.color
        //   : this.options.primaryBtnBgColor,
        "--primaryBgColor": this.$parseColor(this.options.primaryBtnBgColor, {
          isThemeColor: this.options.primaryBtnBgColorIsThemeColor
        }),
        "--primaryBorderStyle": this.options.primaryBtnBorderStyle,
        // "--primaryBorderColor": this.options.primaryBtnBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.primaryBtnBorderIsThemeColor.color
        //   ? this.options.primaryBtnBorderIsThemeColor.color
        //   : this.options.primaryBtnBorderIsThemeColor,
        "--primaryBorderColor": this.$parseColor(this.options.primaryBtnBorderColor, {
          isThemeColor: this.options.primaryBtnBorderIsThemeColor
        }),
        "--primaryBorderWidth": primaryBorderW,
        // "--cancleFontColor": this.options.cancleBtnFontColor,
        "--cancleFontColor": this.$parseColor(this.options.cancleBtnFontColor),
        "--cancleFontFamily": this.options.cancleBtnFontFamily,
        "--cancleFontSize": this.options.cancleBtnFontSize + "px",
        "--cancleFontWeight": this.options.cancleBtnFontWeight,
        // "--cancleBgColor": this.options.cancleBtnBgColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.cancleBtnBgColor.color
        //   ? this.options.cancleBtnBgColor.color
        //   : this.options.cancleBtnBgColor,
        "--cancleBgColor": this.$parseColor(this.options.cancleBtnBgColor, {
          isThemeColor: this.options.cancleBtnBgColorIsThemeColor
        }),
        "--cancleBorderStyle": this.options.cancleBtnBorderStyle,
        // "--cancleBorderColor": this.options.cancleBtnBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.cancleBtnBorderColor.color
        //   ? this.options.cancleBtnBorderColor.color
        //   : this.options.cancleBtnBorderColor,
        "--cancleBorderColor": this.$parseColor(this.options.cancleBtnBorderColor, {
          isThemeColor: this.options.cancleBtnBorderIsThemeColor
        }),
        "--cancleBorderWidth": cancleBorderW
      }
    },
    // 范围输入框的样式
    getRangeInpStyle() {
      let bgColor
      if (this.options.rangeInpBackground) {
        // bgColor = this.options.rangeInpBackground[0].isThemeColor
        //   ? this.themeColor
        //   : this.options.rangeInpBackground[0].color.color || this.options.rangeInpBackground[0].color
        bgColor = this.$parseColor(this.options.rangeInpBackground[0], {
          isThemeColor: this.options.rangeInpBackground[0].isThemeColor
        })
      }
      return {
        "--rangeInpColor": this.$parseColor(this.options.rangeInpFontColor),
        "--rangeInpFontSize": this.options.rangeInpFontSize + "px",
        "--rangeInpFontWeight": this.options.rangeInpFontWeight,
        "--rangeInpFontFamily": this.options.rangeInpFontFamily,
        "--rangeInpBg": bgColor
      }
    },
    getStyle() {
      let borderW = "",
        popperBorderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      if (Array.isArray(this.options.selectBorderWidth)) {
        this.options.selectBorderWidth.forEach(item => [(popperBorderW += ` ${item}px`)])
      } else {
        popperBorderW += ` ${this.options.selectBorderWidth}px`
      }
      return {
        ...this.getNotCurrentMonthStyle,
        ...this.getLineStyle,
        ...this.getPopperTitleStyle,
        ...this.getHoverStyle,
        ...this.getSelectedStyle,
        ...this.getBtnStyle,
        ...this.getRangeInpStyle,
        opacity: this.options.opacity,
        // color: this.options.textIsThemeColor
        //   ? this.themeColor
        //   : this.options.fontColor.color
        //   ? this.options.fontColor.color
        //   : this.options.fontColor,
        color: this.$parseColor(this.options.fontColor, {
          isThemeColor: this.options.textIsThemeColor
        }),
        "font-style": `${this.options.fontStyle}`,
        "font-family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": borderW,
        "box-shadow": this.boxShadowStyle,
        // background: this.options.background[0].isThemeColor
        //   ? this.themeColor
        //   : this.options.background[0].color.color || this.options.background[0].color,
        background: this.$parseColor(this.options.background[0].color, {
          isThemeColor: this.options.background[0].isThemeColor
        }),
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "--marginTop": this.options.heightType
          ? this.options.height + this.options.heightType
          : this.options.height + "px",
        // "--popperBackground": this.options.selectBackground[0].isThemeColor
        //   ? this.themeColor
        //   : this.options.selectBackground[0].color.color || this.options.selectBackground[0].color,
        "--popperBackground": this.$parseColor(this.options.selectBackground[0], {
          isThemeColor: this.options.selectBackground[0].isThemeColor
        }),
        // "--popperColor": this.options.selectFontColor,
        "--popperColor": this.$parseColor(this.options.selectFontColor),
        "--popperFontWeight": this.options.selectFontWeight,
        "--popperFontSize": this.options.selectFontSize + "px",
        "--popperFontFamily": this.options.selectFontFamily,
        "--popperBorderStyle": this.options.selectBorderStyle,
        // "--popperBorderColor": this.options.selectBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.selectBorderColor && this.options.selectBorderColor.color
        //   ? this.options.selectBorderColor.color
        //   : this.options.selectBorderColor,
        "--popperBorderColor": this.$parseColor(this.options.selectBorderColor, {
          isThemeColor: this.options.selectBorderIsThemeColor
        }),
        "--popperBorderWidth": borderW,
        "--popperPaddingTop": this.options.datePaddingTopVal + "px",
        "--popperPaddingBottom": this.options.datePaddingBottomVal + "px"
      }
    },
    hasDateFilterPlugin() {
      return this.options?.pluginName?.includes("dateFilterTablePlugin")
    },
    dateSelectRange() {
      return this.options.dateSelectRange
    },
    selectRangeText() {
      return this.options.selectRangeText || "before"
    },
    selectRangeDate() {
      return this.options.selectRangeDate || "today"
    },
    selectDate() {
      let val = this.options.selectDate
      //  判断 日期 是否为 ISO 8601格式【示例：2024-07-18T03:07:18.619Z】，修改为标准时间格式 示例：Thu Jul 18 2024 11:30:47 GMT+0800 (中国标准时间)
      if(typeof val === "string" && val.indexOf("-") > 0 && val.indexOf("T") > 0 && val.indexOf(".") > 0 && val.indexOf("Z") > 0 ){
        val = new Date(val)
      }
      return val
    }
  },
  watch: {
    dateType(n, o) {
      this.show = false
      setTimeout(() => {
        if (!this.hasDateFilterPlugin) {
          if (Array.isArray(this.value)) {
            this.value = [new Date()]
          } else {
            this.value = new Date()
          }
        }
        this.show = true
      }, 100)
    },
    activeId: {
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal?.rect_id || newVal?.rect_id !== this.ids.rect_id) {
          if (this.dateBlur) {
            let pop = this.$refs.datePickerDiv.$el.lastChild
            pop.style.display = "none"
          }
        }
      }
    },
    dataPickerType(n, o) {
      if (this.request_prefix === "appStage"){
        if (n !== o) {
          this.appendToBodyClass = "app-style-panel"
          if (this.dataPickerType === 3) {
            this.appendToBodyClass = "app-style-panel width414"
          }
        }
      }
    }
  },
  data() {
    return {
      show: true,
      dateBlur: undefined,
      rangeDefaultTime: ['00:00:00', '23:59:59'],
      appendToBody: false,
      appendToBodyClass: "",
      formatMap: {
        'yyyy年MM月dd日': 'YYYY年MM月DD日',
        'yyyy-MM-dd': 'YYYY-MM-DD',
        'yyyy/MM/dd': 'YYYY/MM/DD',
        'yyyy年': 'YYYY年',
        'yyyy年MM月': 'YYYY年MM月',
        'yyyy-MM': 'YYYY-MM',
        'yyyy/MM': 'YYYY/MM',
        'yyyy年MM月dd日 HH:mm:ss': 'YYYY年MM月DD日 HH:mm:ss',
        'yyyy-MM-dd HH:mm:ss': 'YYYY-MM-DD HH:mm:ss',
        'yyyy/MM/dd HH:mm:ss': 'YYYY/MM/DD  HH:mm:ss',
        'yyyy/MM/dd hh:mm:ss': 'YYYY年MM月DD日  HH:mm:ss',
      },
      isInListPage: false,
      isInSubPage: false,
      pickerOptions: {}
    }
  },
  methods: {
    disabledDateFun(time) {
      if (this.dateSelectRange && this.dateType === 'date') {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const yesterday = new Date(today).setDate(new Date(today).getDate() - 1)
        const tomorrow = new Date(today).setDate(new Date(today).getDate() + 1)
        let selectDate = this.selectDate
        const firstWeekDay = this.getWeekDayTime("first")
        const lastWeekDay = this.getWeekDayTime("last")
        const firstMonthDay = this.getFirstMonthDayTime()
        const lastMonthDay = this.getLastMonthDayTime()

        if (this.selectRangeText === "before") {
          if (this.selectRangeDate === "today") {
            return time.getTime()+1 > today
          } else if (this.selectRangeDate === "yesterday") {
            return time.getTime()+1 > yesterday
          } else if (this.selectRangeDate === "tomorrow") {
            return time.getTime()+1 > tomorrow
          } else if (this.selectRangeDate === "week") {
            return time.getTime()+1 > firstWeekDay
          } else if (this.selectRangeDate === "month") {
            return time.getTime()+1 > firstMonthDay
          } else if (this.selectRangeDate === "date") {
            if (selectDate) return time.getTime()+1 > selectDate
            return false
          }
        } else if (this.selectRangeText === "after") {
          if (this.selectRangeDate === "today") {
            return time.getTime()-1 < today
          } else if (this.selectRangeDate === "yesterday") {
            return time.getTime()-1 < yesterday
          } else if (this.selectRangeDate === "tomorrow") {
            return time.getTime()-1 < tomorrow
          } else if (this.selectRangeDate === "week") {
            return time.getTime()-1 < lastWeekDay
          } else if (this.selectRangeDate === "month") {
            return time.getTime()-1 < lastMonthDay
          } else if (this.selectRangeDate === "date") {
            if (selectDate) return time.getTime()-1 < selectDate
            return false
          }

        } else if (this.selectRangeText === "equal") {
          if (this.selectRangeDate === "today") {
            return time.getTime() !== today.getTime()
          } else if (this.selectRangeDate === "yesterday") {
            return time.getTime() !== yesterday
          } else if (this.selectRangeDate === "tomorrow") {
            return time.getTime() !== tomorrow
          } else if (this.selectRangeDate === "week") {
            return !(time.getTime()+1 > firstWeekDay && time.getTime()-1 < lastWeekDay)
          } else if (this.selectRangeDate === "month") {
            return !(time.getTime()+1 > firstMonthDay && time.getTime()-1 < lastMonthDay)
          } else if (this.selectRangeDate === "date") {  
            if (selectDate) return time.getTime() !== selectDate.getTime()
            return false
          }
        }
      } else return false
    },
    getWeekDayTime(type) {
      const today = new Date();
      // 获取今天是周几
      const dayOfWeek = today.getDay()
      // 计算今天距离周一有多少天差异（如果是周日，差异是6；如果是周一，差异是0
      let diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      today.setDate(today.getDate() + diff);
      today.setHours(0, 0, 0, 0)
      if (type === "last") {
        const lastDayOfWeek = today
        lastDayOfWeek.setDate(today.getDate() + 6)
        // 获取最后一天的时间戳
        return lastDayOfWeek.getTime();
      }
      // 返回本周第一天的时间戳
      return today.getTime();
    },
    getFirstMonthDayTime() {
      const currentDate = new Date()
      currentDate.setDate(1)
      currentDate.setHours(0, 0, 0, 0)
      return currentDate.getTime()
    },
    getLastMonthDayTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth(); // 0 表示1月，1表示2月，以此类推
      const lastDayOfMonth = new Date(year, month + 1, 0); // 直接设置为下个月的第一天的前一天
      return lastDayOfMonth.getTime(); // 获取时间戳
    },
    initListPageDatePickerData(listPage) {
      const { dataLayoutOptions } = listPage
      // 初始化列表页筛选的相关功能
      this.isInListPage = true
      this.dataLayoutId = {
        container_id: 0,
        rect_id: dataLayoutOptions.rect_id
      }
    },
    initSubPageDatePickerData(plugin) {
      // 初始化列表页筛选的相关功能
      this.isInSubPage = true
    },
    // 获取自由布局的字段详情数据
    // 组装用于筛选的日期值
    formatFilterValue(value) {
      const filterValue = this.getPickerValue(value, this.dateFormat, this.dateType)
      console.log('当前选中时间是', value, this.getPickerValue(value, this.dateFormat, this.dateType))
      this.$eventBus.$emit(
        `update-layout-data-eventBus-${this.dataLayoutId?.container_id}-${this.dataLayoutId?.rect_id}`,
        {
          dateVal: filterValue ? [this.startDateFlag, this.endDateFlag, filterValue[0], filterValue[1]] : null
        }
      )
    },
    // 触发列表页数据刷新
    dispatchListPageRefreshData(value) {
      const filterValue = this.getPickerValue(value, this.dateFormat, this.dateType)
      const dateVal = filterValue ? [this.startDateFlag, this.endDateFlag, filterValue[0], filterValue[1]] : [this.startDateFlag, this.endDateFlag, "", ""]
      if (dateVal && this.$subPageEvent.contexts) {
        Object.keys(this.$subPageEvent.contexts).forEach(key => {
          if (key.indexOf("cxDataGrid") !== -1) {
            this.$eventBus.$emit("subPage-component-init", {
              type: key,
              dateVal: dateVal
            })
          }
        })
      }
    },
    getPickerValue(value, format, dateType) {
      if (!this.startDateFlag || !this.endDateFlag) return null
      if (Object.prototype.toString.call(value) === '[object Date]' && this.dateType !== 'week') {
        value = dayjs(value.toString()).format(this.formatMap[this.dateFormat] || this.dateFormat)
      }
      if (['daterange', 'datetimerange', 'monthrange'].includes(dateType) && (!Array.isArray(value) || value.length !== 2)) {
        return null
      }
      if (!value) return null
      format = this.formatMap[format] || format
      let targetDateValue = ['']
      let targetDateFormat = 'YYYY-MM-DD'
      switch (dateType) {
        case 'date':
        case 'datetime': {
          targetDateValue = [dayjs(value, format, 'zh-cn').format(targetDateFormat), dayjs(value, format, 'zh-cn').format(targetDateFormat)]
        };break
        case 'week': {
          targetDateValue = [dayjs(value).startOf('week').format(targetDateFormat), dayjs(value).endOf('week').format(targetDateFormat)]
        };break
        case 'month': {
          targetDateValue = [dayjs(value, format, 'zh-cn').startOf('month').format(targetDateFormat), dayjs(value, format).endOf('month').format(targetDateFormat)]
        };break
        case 'year': {
          targetDateValue = [dayjs(value, format, 'zh-cn').startOf('year').format(targetDateFormat), dayjs(value, format).endOf('year').format(targetDateFormat)]
        };break
        case 'daterange':
        case 'datetimerange': {
          targetDateValue = [dayjs(value[0], format, 'zh-cn').format(targetDateFormat), dayjs(value[1], format).format(targetDateFormat)]
        };break;
        case 'monthrange': {
          targetDateValue = [dayjs(value[0], format, 'zh-cn').startOf('month').format(targetDateFormat), dayjs(value[1], format).endOf('month').format(targetDateFormat)]
        }
      }
      return targetDateValue
    },
    changeDate(val) {
      if(!val){
        if (this.dateType.indexOf("range") > -1 && this.hasDateFilterPlugin) {
          this.$changeOptionsEV("", "startDate", false, undefined, this.myid)
        }
        return
      }
      // 将数据处理成传参需要的格式
      // 单个sw=2022-05-17； 多个sw=2022-05-17###2022-05-17###2022-05-17； 时间区间，用dateCollum形式   sd=2023-03-01&ed=2023-04-21
      // 时间区间，用dateCollum形式   sw=2023-03-01#2023-04-21  暂时用这个 后面考虑交互是否添加传其他参数的功能
      // 针对表单的筛选 包含时分秒的时候需要把秒去除掉
      let ssLength = 0,
        mmEndIndex
      if (this.options.dateFormat.indexOf("ss") > -1) {
        mmEndIndex = this.options.dateFormat.indexOf("mm") + 2
        ssLength = this.options.dateFormat.length - mmEndIndex
      }
      if (this.dateType.indexOf("range") > -1) {
        let range = ssLength > 0 ? `${val[0].slice(0, -ssLength)}#${val[1].slice(0, -ssLength)}` : `${val[0]}#${val[1]}`
        this.$changeOptionsEV(range, "startDate", false, undefined, this.myid)
        // this.$changeOptionsEV(val[0], "startDate", false, undefined, this.myid)
        // this.$changeOptionsEV(val[1], "endDate", false, undefined, this.myid)
      } else {
        let dates = ""
        if (Array.isArray(val)) {
          val.forEach((item, index) => {
            let newItem = ssLength > 0 ? item.slice(0, -ssLength) : item
            let tempData = index === 0 ? `${newItem}` : `###${newItem}`
            dates += tempData
          })
        } else {
          dates = ssLength > 0 ? val.slice(0, -ssLength) : val
        }
        this.$changeOptionsEV(dates, "dates", false, undefined, this.myid)
      }
    },
    blurDateFn() {
      this.dateBlur = true
      if (!this.isBigScreenPreview()) {
        setTimeout(() => {
          if (this.activeId?.rect_id === this.ids.rect_id) {
            let pop = this.$refs.datePickerDiv.$el.lastChild
            pop.style.display = "block"
            if (this.options.dataPickerType === 3) {
              pop.style.position = "absolute"
              pop.style.right = "4px"
            }
          }
        }, 1000)
      }
    },
    changeToNow() {
      let now1 = new Date()
      if (this.dateType.indexOf("range") !== -1) {
        let start = new Date()
        let end = new Date()
        if(this.dateType === "monthrange"){
          start.setMonth(start.getMonth() - Number(this.options.todayRange))
          this.value = [start, end]
        }
        else if(this.dateType === "daterange" ){
          start.setDate(start.getDate() - Number(this.options.todayRange))
          this.value = [start, end]
        }else if(this.dateType === "datetimerange"){
          start.setDate(start.getDate() - Number(this.options.todayRange))
          start.setHours(start.getHours() - Number(this.options.todayRangeTime))
          start.setMinutes(0)
          start.setSeconds(0)
          end.setMinutes(0)
          end.setSeconds(0)
          this.value = [start, end]
        }
        /* 修改值 */
        let range = this.changeDateStyle(start) + "#" + this.changeDateStyle(end)
        this.$changeOptionsEV(range, "startDate", false, undefined, this.myid)
      }else{
        this.value = now1
      }
    },
  //  转换日期格式
    changeDateStyle(time){
      let month = Number(time.getMonth() + 1) < 10 ? "0" + Number(time.getMonth() + 1) : Number(time.getMonth() + 1)
      let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
      let hour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours()
      if(this.dateType === "datetimerange"){
        //datetimerange
        time = time.getFullYear() + "-" + month + "-" + day + " " + hour + ":00"
      }else if(this.dateType === "daterange"){
        //daterange
        time = time.getFullYear() + "-" + month + "-" + day
      }else{
        //monthrange
        time = time.getFullYear() + "-" + month
      }
      return time
    }
  }
}
</script>

<style scoped>
.cx-datePicker {
  height: 100%;
}
::v-deep .el-date-editor {
  width: 100%;
  height: 100%;
}
::v-deep .el-date-editor .el-range__icon,
::v-deep .el-date-editor .el-input__icon {
  display: inline-block;
  vertical-align: middle;
  height: auto;
}
::v-deep .el-input .el-input__inner:focus {
  box-shadow: none;
}
::v-deep .el-date-editor .el-range__icon,
::v-deep .el-date-editor.el-input .el-input__inner,
::v-deep .el-date-editor .el-range-input {
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
}
::v-deep .el-date-editor .el-range-input {
  background-color: transparent;
  /*font-size: inherit;*/
  /*font-family: inherit;*/
  /*font-weight: inherit;*/
}
::v-deep .el-date-editor .el-range-input::placeholder {
  font-size: inherit;
}
::v-deep .el-date-editor .el-input__icon:after {
  display: none;
}
::v-deep .el-input__suffix,
::v-deep .el-input__icon {
  display: inline-block;
  vertical-align: middle;
  height: auto;
}
::v-deep .el-input__prefix,
::v-deep .el-input__suffix {
  top: 50%;
  transform: translateY(-50%);
  color: inherit;
}
::v-deep .el-input__icon {
  color: inherit;
}
::v-deep .el-date-editor .el-input__prefix {
  display: flex;
  align-items: center;
}
::v-deep .el-date-editor .el-range-separator {
  display: flex;
  align-items: center;
  color: inherit;
}
::v-deep .el-date-editor > .el-input__inner,
::v-deep .el-date-editor > .el-input__inner:hover {
  height: 100%;
  background: transparent;
}
::v-deep .el-input .el-input__inner {
  color: rgba(255, 255, 255, 0.2);
  padding-left: 30px;
}
::v-deep .el-time-panel {
  /*background: var(--popperBackground);*/
  border-width: var(--popperBorderWidth);
  border-style: var(--popperBorderStyle);
  border-color: var(--popperBorderColor);
  background: var(--rangeInpBg);
}
::v-deep .el-picker-panel {
  left: 0 !important;
  background: var(--popperBackground);
  top: var(--marginTop) !important;
  border-width: var(--popperBorderWidth);
  border-style: var(--popperBorderStyle);
  border-color: var(--popperBorderColor);
}
::v-deep .el-date-picker__header--bordered,
::v-deep .el-date-table th {
  border-bottom-color: var(--popperBorderColor);
}
::v-deep .el-picker-panel__footer {
  background: transparent;
  border-color: var(--popperBorderColor);
}
::v-deep .el-input__inner「 {
  padding-left: 30px;
}
::v-deep .el-date-table td {
  padding-top: var(--popperPaddingTop);
  padding-bottom: var(--popperPaddingBottom);
}
::v-deep .el-date-table th,
::v-deep .el-date-table td span {
  font-size: var(--popperFontSize);
  font-weight: var(--popperFontWeight);
  font-family: var(--popperFontFamily);
}
::v-deep .el-date-table th,
::v-deep .el-date-table .available span {
  color: var(--popperColor);
}
::v-deep .el-date-table td.next-month,
::v-deep .el-date-table td.prev-month {
  color: var(--notCurrentMonthColor);
}
::v-deep .el-date-range-picker__header,
::v-deep .el-date-picker__header {
  margin: 0;
  padding: var(--titlePadding);
  background: var(--titleBackground);
  letter-spacing: var(--titleLetterSpacing);
  text-align: var(--titleTextAlign);
  writing-mode: var(--titleWritingMode);
  text-decoration: var(--titleTextDecoration);
  text-decoration-color: var(--titleTextDecorationColor);
  height: auto;
}
::v-deep .el-date-range-picker__header,
::v-deep .el-picker-panel__icon-btn,
::v-deep .el-date-picker__header-label {
  margin-top: 0;
  line-height: var(--titleLineHeight);
  font-family: var(--titleFontFamily);
  font-size: var(--titleFontSize);
  font-weight: var(--titleFontWeight);
  font-style: var(--titleFontStyle);
  color: var(--titleColor);
}
::v-deep .el-date-range-picker__header div {
  font-size: var(--titleFontSize);
  font-weight: var(--titleFontWeight);
}

::v-deep .el-date-table td.available:hover span {
  font-size: var(--hoverFontSize);
  font-weight: var(--hoverFontWeight);
  font-family: var(--hoverFontFamily);
  color: var(--hoverColor);
  border: var(--hoverBorder);
  background: var(--hoverBackground);
  border-radius: var(--hoverBorderRadiusTopLeft) var(--hoverBorderRadiusTopRight) var(--hoverBorderRadiusBottomRight)
    var(--hoverBorderRadiusBottomLeft);
}
/*选中项的样式高于悬浮的样式*/
::v-deep .el-date-table td.current:not(.disabled) span,
::v-deep .el-date-table td.in-range span,
::v-deep .el-date-table td.selected span,
::v-deep .el-month-table td.in-range .cell,
::v-deep .el-month-table td.in-range .cell{
  font-size: var(--activeFontSize);
  font-weight: var(--activeFontWeight);
  font-family: var(--activeFontFamily);
  color: var(--activeColor);
  background: var(--activeBackground);
}
::v-deep .el-date-table td.current:not(.disabled) span,
::v-deep .el-date-table td.selected:not(.disabled) span {
  border: var(--activeBorder);
  border-radius: var(--activeBorderRadiusTopLeft) var(--activeBorderRadiusTopRight) var(--activeBorderRadiusBottomRight)
    var(--activeBorderRadiusBottomLeft);
}
::v-deep .el-date-table td.in-range > div {
  border-top: var(--activeBorder);
  border-bottom: var(--activeBorder);
}
::v-deep .el-date-table td.start-date > div {
  border-left: var(--activeBorder);
  border-top-left-radius: var(--activeBorderRadiusTopLeft);
  border-bottom-left-radius: var(--activeBorderRadiusBottomLeft);
}
::v-deep .el-date-table td.end-date > div {
  border-right: var(--activeBorder);
  border-top-right-radius: var(--activeBorderRadiusTopRight);
  border-bottom-right-radius: var(--activeBorderRadiusBottomRight);
}
::v-deep .el-date-table td.end-date span,
::v-deep .el-date-table td.start-date span {
  background: transparent;
}
::v-deep .el-date-table td.in-range div,
::v-deep .el-date-table td.in-range div:hover,
::v-deep .el-date-table.is-week-mode .el-date-table__row.current div,
::v-deep .el-date-table.is-week-mode .el-date-table__row:hover div,
::v-deep .el-month-table td.in-range div,
::v-deep .el-month-table td.in-range div:hover{
  background: var(--activeBackground);
}
/*选择器弹框的分割线样式*/
::v-deep .el-time-panel__content::after,
::v-deep .el-time-panel__content::before {
  border-top-color: var(--lineColor);
  border-bottom-color: var(--lineColor);
}
::v-deep .el-time-panel__footer {
  border-top-color: var(--lineColor);
}
::v-deep .el-date-range-picker__content.is-left {
  border-right-color: var(--lineColor);
}
::v-deep .el-date-range-picker__time-header {
  border-bottom-color: var(--lineColor);
}
/*按钮的样式*/
::v-deep .el-time-panel__footer .cancel,
::v-deep .el-picker-panel__footer .el-button {
  font-size: var(--cancleFontSize);
  font-weight: var(--cancleFontWeight);
  font-family: var(--cancleFontFamily);
  color: var(--cancleFontColor);
  border-style: var(--cancleBorderStyle);
  border-width: var(--cancleBorderWidth);
  border-color: var(--cancleBorderColor);
  background: var(--cancleBgColor);
}
::v-deep .el-time-panel__footer .el-time-panel__btn {
  line-height: 24px;
}
::v-deep .el-picker-panel__footer .el-button {
  padding: 8px 15px;
}
::v-deep .el-time-panel__footer .confirm,
::v-deep .el-picker-panel__footer .el-button--default {
  font-size: var(--primaryFontSize);
  font-weight: var(--primaryFontWeight);
  font-family: var(--primaryFontFamily);
  color: var(--primaryFontColor) !important;
  border-style: var(--primaryBorderStyle);
  border-width: var(--primaryBorderWidth);
  border-color: var(--primaryBorderColor) !important;
  background: var(--primaryBgColor) !important;
}
::v-deep .el-time-spinner__item:hover:not(.disabled):not(.active) {
  background-color: transparent;
}
/*样式3的默认样式去掉*/
::v-deep .el-date-table td.available.selected div {
  background-color: transparent;
}
/*范围输入框*/
::v-deep .el-time-panel .el-time-spinner__item.active:not(.disabled) {
  color: var(--rangeInpColor) !important;
  font-size: var(--rangeInpFontSize);
  font-family: var(--rangeInpFontFamily);
  font-weight: var(--rangeInpFontWeight);
}
::v-deep .editPageHome .el-date-editor .el-range-input::placeholder {
  color: rgba(0, 0, 0, 0.2);
}
::v-deep .bigScreen .el-input.is-disabled .el-input__inner,
::v-deep .el-date-editor .el-date-range-picker__editor .el-input__inner::placeholder,
::v-deep .el-date-editor .el-date-range-picker__editor .el-input__inner {
  color: var(--rangeInpColor) !important;
  font-size: var(--rangeInpFontSize);
  font-family: var(--rangeInpFontFamily);
  font-weight: var(--rangeInpFontWeight);
  background: var(--rangeInpBg);
  padding-left: 0;
  text-align: center;
}
.relativeTable ::v-deep .el-picker-panel{
  position: absolute;
}
::v-deep .el-date-table td.disabled div {
  background-color: transparent;
}
::v-deep .el-date-table td.disabled div>span {
  color: #c0c4cc !important;
}
</style>
<style lang="scss">
.bigScreen .el-date-table td.disabled div>span,
.bigScreenStage .el-date-table td.disabled div>span{
  color: var(--notCurrentMonthColor) !important;
}
</style>
<style lang="scss" scoped>
  ::v-deep .el-picker-panel.app-style-panel {
    left: 0 !important;
    &.width414 {
      width: 414px;
    }
    .el-picker-panel__body{
      min-width: auto;
    }
    .el-date-range-picker__time-header{
      display: grid;
      *{
        display: inline-block;
      }
    }
    .el-picker-panel__icon-btn{
      font-size: 20px;
    }
    .el-date-range-picker__content .el-date-range-picker__header div{
      margin-left: 30px;
      margin-right: 30px;
    }
    .el-date-range-picker__content{
      padding: 16px 8px;
    }
  }
</style>
